import React from "react";

const DropdownInput = ({
  selectedOption,
  onChange,
  selectCaption,
  items,
  value,
  label,
  validationMessage,
  required,
  disabled,
  className,
}) => {
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <>
      <select
        disabled={disabled}
        id="countries"
        className={`block w-full p-2 text-lg leading-normal font-normal placeholder:text-medium-grey border border-light-grey-500 rounded-lg bg-white focus:border-light-grey-100 ${className}`}
        value={
          selectedOption === false
            ? JSON.stringify(selectedOption)
            : selectedOption
            ? selectedOption
            : ""
        }
        onChange={handleSelectChange}
      >
        <option value="">{selectCaption || "Select Option"}</option>

        {Array.isArray(items) &&
          items.length > 0 &&
          items.map((item, index) => (
            <option key={index} value={item[value]?.toString()}>
              {item[label]}
            </option>
          ))}
      </select>

      {required && (selectedOption === "" || selectedOption === null) && (
        <p className="mt-2 text-red-500 text-xs">
          {validationMessage ? validationMessage : "This field is required"}
        </p>
      )}
    </>
  );
};

export default DropdownInput;
